export default {
  freeTrialEndPeriod: 7,
  assignee: null,
};
